/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { NotFoundPage, SecurityHelper, useFlags } from 'sarsaparilla';

export function SoftReleaseWrapper({
    softReleaseUserIdsFlagName = '',
    fallback,
    children,
}) {
    const { [softReleaseUserIdsFlagName]: userIdsList } = useFlags();
    try {
        if (!userIdsList || userIdsList == null) {
            return null;
        }

        const { account_id = null } = SecurityHelper.getAccount();

        if (userIdsList.includes(account_id)) {
            return <>{children}</>;
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }

    return <>{fallback}</>;
}

const withSoftReleaseCheck = (Component) =>
    function ({ doUserCheck = false, softReleaseUserIdsFlagName = '', ...props }) {
        if (!doUserCheck) {
            return <Component {...props} />;
        }

        return (
            <SoftReleaseWrapper
                softReleaseUserIdsFlagName={softReleaseUserIdsFlagName}
                fallback={<NotFoundPage />}
            >
                <Component {...props} />
            </SoftReleaseWrapper>
        );
    };

SoftReleaseWrapper.propTypes = {
    softReleaseUserIdsFlagName: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    fallback: PropTypes.node,
};

export default withSoftReleaseCheck;
